import { EarlyWarningTypeTypes } from "../components/createWarningComp/CreateWarningTypes";
import { RecipientType } from "../components/earlyWarning/emailComp/EmailTypes";

const BASE_URL = process.env.REACT_APP_BASE_URL

const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

// Get all early warning types
export const API_GET_ALL_EARLY_WARNING_TYPES_URL: string = 'http://localhost:8083/early_warning/type/get-all'

export type APIResponseGetWarningTypeTypes = {
    id: string;
    type: string;
    code: string;
}

// Add new early warning
export const API_ADD_NEW_EARLY_WARNING_TYPE_URL: string = 'http://localhost:8083/early_warning/add-new'

export type APIRequestNewEarlyWarningType = {
    accessToken: string;
    type: string;
    name: string;
    description: string;
}

// Get all warnings
export const API_GET_ALL_EARLY_WARNINGS_URL: string = 'http://localhost:8083/early_warning/get-all'

export type APIResponseGetEarlyWarningsTypes = {
    id: string;
    type: APIResponseGetWarningTypeTypes;
    name: string;
    description: string;
}

// Get early warning by value
export const API_GET_WARNING_BY_VALUE_URL: string = 'http://localhost:8083/early_warning/get'

export type APIRequestGetEarlyWaringByValueTypes = {
    value: string;
}

// Update early warning
export const API_UPDATE_WARNING_URL: string = 'http://localhost:8083/early_warning/update'

export type APIRequestUpdateWarningTypes = {
    accessToken: string,
    id: string;
    type: string;
    name: string;
    description: string;
}

// Delete early warning by value
export const API_EARLY_WARNING_DELETE_BY_VALUE_URL: string = 'http://localhost:8083/early_warning/delete'

export type APIRequestDeleteEarlyWarningByValueTypes = {
    accessToken: string,
    value: string;
}


const toISOStringSafe = (dateStr: string | undefined, index: number): string => {
    const date = new Date(dateStr || '');
    if (isNaN(date.getTime())) {
        console.warn(`Invalid date: "${dateStr}" at index ${index}`);
        return ''; // or throw error, or skip appending
    }
    return date.toISOString();
}

export type ResponseTypes = {
    message: string;
    httpStatus: string;
    data?: any;
    errorCode?: number;
    errorMessage?: number;
    access_token?: string
}

// Add Heavy Rain Early Warning
const API_EARLY_WARNING_ADD_HRW: string = `${BASE_URL}/ew/api/v1/add_hrw`

export type APIRequestAddHRWAreaTypes = {
    administrationName: string;
    administrationLevel: string;
    previousAlertLevel: string;
    newAlertLevel: string;
    rainfall: number;
    lightingRiskLevel: string;
    startDate: string;
    endDate: string;
}

export type APIRequestAddHRWTypes = {
    hrwNumber: string;
    type?: string;
    requestName: string;
    contactNumber: string;
    preRequestDocument: string;
    validityStartTime: string;
    validityEndTime: string;
    primaryCause: string;
    riskLevel: string;
    hrwDate: string;
    requestersDepartment: string;
    administrationData: APIRequestAddHRWAreaTypes[];
    messageBodyEnglish: string;
    messageBodyDhivehi: string;
    messageBodySinhala: string;
    reportLink: string;
    supportiveDocuments: File | null;
    warningId: string;
}

export const APICallNewHRWRequest = async (body: APIRequestAddHRWTypes): Promise<ResponseTypes> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token")
    }

    try {
        const formData = new FormData();

        formData.append("hrwNumber", body.hrwNumber);
        formData.append("type", body.type || "");
        formData.append("requestName", body.requestName);
        formData.append("contactNumber", body.contactNumber);
        formData.append("preRequestDocument", body.preRequestDocument);
        formData.append("validityStartTime", body.validityStartTime); // ISO string
        formData.append("validityEndTime", body.validityEndTime);     // ISO string
        formData.append("primaryCause", body.primaryCause);
        formData.append("riskLevel", body.riskLevel);
        formData.append("hrwDate", body.hrwDate);
        formData.append("requestersDepartment", body.requestersDepartment);
        formData.append("messageBodyEnglish", body.messageBodyEnglish);
        formData.append("messageBodyDhivehi", body.messageBodyDhivehi);
        formData.append("messageBodySinhala", body.messageBodySinhala);
        formData.append("reportLink", body.reportLink);
        formData.append("warningId", body.warningId)

        if (body.supportiveDocuments) {
            formData.append("supportiveDocuments", body.supportiveDocuments);
        }

        body.administrationData.forEach((admin: APIRequestAddHRWAreaTypes, index: number) => {

            formData.append(`administrationData[${index}].administrationName`, admin.administrationName);
            formData.append(`administrationData[${index}].administrationLevel`, admin.administrationLevel);
            formData.append(`administrationData[${index}].previousAlertLevel`, admin.previousAlertLevel);
            formData.append(`administrationData[${index}].newAlertLevel`, admin.newAlertLevel);
            formData.append(`administrationData[${index}].rainfall`, admin.rainfall !== undefined ? admin.rainfall.toString() : '0');
            formData.append(`administrationData[${index}].lightingRiskLevel`, admin.lightingRiskLevel);
            formData.append(`administrationData[${index}].startDate`, admin.startDate);
            formData.append(`administrationData[${index}].endDate`, admin.endDate);
        })


        const options: RequestInit = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`
            },
            body: formData
        }

        const response = await fetch(API_EARLY_WARNING_ADD_HRW, options);
        const responseData = await response.json()

        if (!response.ok) {
            //alert(responseData.message || 'Unknown error')
            throw new Error(responseData.message || 'Request failed')
        }

        return responseData as ResponseTypes
    }
    catch (error) {
        console.error('API call error:', error)
        //alert('Error connecting to backend')
        throw error
    }
}

// Add Land Slide Warning
const API_EARLY_WARNING_ADD_LSW: string = `${BASE_URL}/ew/api/v1/add_lsw`

export type APIRequestAddLSWAreaTypes = {
    administrationName: string;
    administrationLevel: string;
    previousAlertLevel: string;
    newAlertLevel: string;
    rainfall: number;
    lightingRiskLevel: string;
    startDate: string;
    endDate: string;
}

export type APIRequestAddLSWTypes = {
    lswNumber: string;
    type?: string;
    requestName: string;
    contactNumber: string;
    preRequestDocument: string;
    validityStartTime: string;
    validityEndTime: string;
    primaryCause: string;
    riskLevel: string;
    lswDate: string;
    requestersDepartment: string;
    administrationData: APIRequestAddLSWAreaTypes[];
    messageBodyEnglish: string;
    messageBodyDhivehi: string;
    messageBodySinhala: string;
    reportLink: string;
    supportiveDocuments: File | null;
    warningId: string;
}

export const APICallNewLSWRequest = async (body: APIRequestAddLSWTypes): Promise<ResponseTypes> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const formData = new FormData();

        formData.append("lswNumber", body.lswNumber);
        formData.append("type", body.type || "");
        formData.append("requestName", body.requestName);
        formData.append("contactNumber", body.contactNumber);
        formData.append("preRequestDocument", body.preRequestDocument);
        formData.append("validityStartTime", body.validityStartTime);
        formData.append("validityEndTime", body.validityEndTime);
        formData.append("primaryCause", body.primaryCause);
        formData.append("riskLevel", body.riskLevel);
        formData.append("lswDate", body.lswDate);
        formData.append("requestersDepartment", body.requestersDepartment);
        formData.append("messageBodyEnglish", body.messageBodyEnglish);
        formData.append("messageBodyDhivehi", body.messageBodyDhivehi);
        formData.append("messageBodySinhala", body.messageBodySinhala);
        formData.append("reportLink", body.reportLink);
        formData.append("warningId", body.warningId)

        if (body.supportiveDocuments) {
            formData.append("supportiveDocuments", body.supportiveDocuments);
        }

        body.administrationData.forEach((admin: APIRequestAddLSWAreaTypes, index: number) => {

            formData.append(`administrationData[${index}].administrationName`, admin.administrationName);
            formData.append(`administrationData[${index}].administrationLevel`, admin.administrationLevel);
            formData.append(`administrationData[${index}].previousAlertLevel`, admin.previousAlertLevel);
            formData.append(`administrationData[${index}].newAlertLevel`, admin.newAlertLevel);
            formData.append(`administrationData[${index}].rainfall`, admin.rainfall !== undefined ? admin.rainfall.toString() : '0');
            formData.append(`administrationData[${index}].lightingRiskLevel`, admin.lightingRiskLevel);
            formData.append(`administrationData[${index}].startDate`, admin.startDate);
            formData.append(`administrationData[${index}].endDate`, admin.endDate);
        });

        const options: RequestInit = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`
            },
            body: formData
        };

        const response = await fetch(API_EARLY_WARNING_ADD_LSW, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || 'Request failed');
        }

        return responseData as ResponseTypes;
    } catch (error) {
        console.error('API call error:', error);
        throw error;
    }
}

// Add flood Warning
const API_EARLY_WARNING_ADD_FLW: string = `${BASE_URL}/ew/api/v1/add_flw`

export type APIRequestAddFLWAreaTypes = {
    administrationName: string;
    administrationLevel: string;
    previousAlertLevel: string;
    newAlertLevel: string;
    rainfall: number;
    lightingRiskLevel: string;
    startDate: string;
    endDate: string;
}

export type APIRequestAddFLWTypes = {
    flwNumber: string;
    type?: string;
    requestName: string;
    contactNumber: string;
    preRequestDocument: string;
    validityStartTime: string;
    validityEndTime: string;
    primaryCause: string;
    riskLevel: string;
    flwDate: string;
    requestersDepartment: string;
    administrationData: APIRequestAddFLWAreaTypes[];
    messageBodyEnglish: string;
    messageBodyDhivehi: string;
    messageBodySinhala: string;
    reportLink: string;
    supportiveDocuments: File | null;
    warningId: string;
}

export const APICallNewFLWRequest = async (body: APIRequestAddFLWTypes): Promise<ResponseTypes> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const formData = new FormData();

        formData.append("flwNumber", body.flwNumber);
        formData.append("type", body.type || "");
        formData.append("requestName", body.requestName);
        formData.append("contactNumber", body.contactNumber);
        formData.append("preRequestDocument", body.preRequestDocument);
        formData.append("validityStartTime", body.validityStartTime);
        formData.append("validityEndTime", body.validityEndTime);
        formData.append("primaryCause", body.primaryCause);
        formData.append("riskLevel", body.riskLevel);
        formData.append("flwDate", body.flwDate);
        formData.append("requestersDepartment", body.requestersDepartment);
        formData.append("messageBodyEnglish", body.messageBodyEnglish);
        formData.append("messageBodyDhivehi", body.messageBodyDhivehi);
        formData.append("messageBodySinhala", body.messageBodySinhala);
        formData.append("reportLink", body.reportLink);
        formData.append("warningId", body.warningId)

        if (body.supportiveDocuments) {
            formData.append("supportiveDocuments", body.supportiveDocuments);
        }

        body.administrationData.forEach((admin: APIRequestAddFLWAreaTypes, index: number) => {
            formData.append(`administrationData[${index}].administrationName`, admin.administrationName);
            formData.append(`administrationData[${index}].administrationLevel`, admin.administrationLevel);
            formData.append(`administrationData[${index}].previousAlertLevel`, admin.previousAlertLevel);
            formData.append(`administrationData[${index}].newAlertLevel`, admin.newAlertLevel);
            formData.append(`administrationData[${index}].rainfall`, admin.rainfall !== undefined ? admin.rainfall.toString() : '0');
            formData.append(`administrationData[${index}].lightingRiskLevel`, admin.lightingRiskLevel);
            formData.append(`administrationData[${index}].startDate`, admin.startDate);
            formData.append(`administrationData[${index}].endDate`, admin.endDate);
        });

        const options: RequestInit = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        };

        const response = await fetch(API_EARLY_WARNING_ADD_FLW, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || 'Request failed');
        }

        return responseData as ResponseTypes;
    } catch (error) {
        console.error('API call error:', error);
        throw error;
    }
}

// Add Severe lightning Warning
const API_EARLY_WARNING_ADD_LIG: string = `${BASE_URL}/ew/api/v1/add_lig`

export type APIRequestAddLIGAreaTypes = {
    administrationName: string;
    administrationLevel: string;
    previousAlertLevel: string;
    newAlertLevel: string;
    lightingRiskLevel: string;
    startDate: string;
    endDate: string;
}

export type APIRequestAddLIGTypes = {
    ligNumber: string;
    type?: string;
    requestName: string;
    contactNumber: string;
    preRequestDocument: string;
    validityStartTime: string;
    validityEndTime: string;
    ligDate: string;
    requestersDepartment: string;
    administrationData: APIRequestAddLIGAreaTypes[];
    messageBodyEnglish: string;
    messageBodyDhivehi: string;
    messageBodySinhala: string;
    reportLink: string;
    supportiveDocuments: File | null;
    warningId: string;
}

export const APICallNewLIGRequest = async (body: APIRequestAddLIGTypes): Promise<ResponseTypes> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const formData = new FormData();

        formData.append("ligNumber", body.ligNumber);
        formData.append("type", body.type || "");
        formData.append("requestName", body.requestName);
        formData.append("contactNumber", body.contactNumber);
        formData.append("preRequestDocument", body.preRequestDocument);
        formData.append("validityStartTime", body.validityStartTime);
        formData.append("validityEndTime", body.validityEndTime);
        formData.append("ligDate", body.ligDate);
        formData.append("requestersDepartment", body.requestersDepartment);
        formData.append("messageBodyEnglish", body.messageBodyEnglish);
        formData.append("messageBodyDhivehi", body.messageBodyDhivehi);
        formData.append("messageBodySinhala", body.messageBodySinhala);
        formData.append("reportLink", body.reportLink);
        formData.append("warningId", body.warningId)

        if (body.supportiveDocuments) {
            formData.append("supportiveDocuments", body.supportiveDocuments);
        }

        body.administrationData.forEach((admin: APIRequestAddLIGAreaTypes, index: number) => {
            formData.append(`administrationData[${index}].administrationName`, admin.administrationName);
            formData.append(`administrationData[${index}].administrationLevel`, admin.administrationLevel);
            formData.append(`administrationData[${index}].previousAlertLevel`, admin.previousAlertLevel);
            formData.append(`administrationData[${index}].newAlertLevel`, admin.newAlertLevel);
            formData.append(`administrationData[${index}].lightingRiskLevel`, admin.lightingRiskLevel);
            formData.append(`administrationData[${index}].startDate`, toISOStringSafe(admin.startDate, index));
            formData.append(`administrationData[${index}].endDate`, toISOStringSafe(admin.endDate, index));
        });

        const options: RequestInit = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        };

        const response = await fetch(API_EARLY_WARNING_ADD_LIG, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        return responseData as ResponseTypes;
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

// Add High Wind Warning
const API_EARLY_WARNING_ADD_HWN: string = `${BASE_URL}/ew/api/v1/add_hwn`

export type APIRequestAddHWNAreaTypes = {
    administrationName: string;
    administrationLevel: string;
    minWind: number;
    maxWind: number;
    severity: string;
    lighting: string;
    startDate: string;
    endDate: string;
}

export type APIRequestAddHWNTypes = {
    hwnNumber: string;
    type?: string;
    requestName: string;
    contactNumber: string;
    preRequestDocument: string;
    validityStartTime: string;
    validityEndTime: string;
    primaryCause: string;
    hwnDate: string;
    requestersDepartment: string;
    administrationData: APIRequestAddHWNAreaTypes[];
    messageBodyEnglish: string;
    messageBodyDhivehi: string;
    messageBodySinhala: string;
    reportLink: string;
    supportiveDocuments: File | null;
    warningId: string;
}

export const APICallNewHWNRequest = async (body: APIRequestAddHWNTypes): Promise<ResponseTypes> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const formData = new FormData();

        formData.append("hwnNumber", body.hwnNumber);
        formData.append("type", body.type || "");
        formData.append("requestName", body.requestName);
        formData.append("contactNumber", body.contactNumber);
        formData.append("preRequestDocument", body.preRequestDocument);
        formData.append("validityStartTime", body.validityStartTime);
        formData.append("validityEndTime", body.validityEndTime);
        formData.append("primaryCause", body.primaryCause);
        formData.append("hwnDate", body.hwnDate);
        formData.append("requestersDepartment", body.requestersDepartment);
        formData.append("messageBodyEnglish", body.messageBodyEnglish);
        formData.append("messageBodyDhivehi", body.messageBodyDhivehi);
        formData.append("messageBodySinhala", body.messageBodySinhala);
        formData.append("reportLink", body.reportLink);
        formData.append("warningId", body.warningId)

        if (body.supportiveDocuments) {
            formData.append("supportiveDocuments", body.supportiveDocuments);
        }

        body.administrationData.forEach((admin: APIRequestAddHWNAreaTypes, index: number) => {
            formData.append(`administrationData[${index}].administrationName`, admin.administrationName);
            formData.append(`administrationData[${index}].administrationLevel`, admin.administrationLevel);
            formData.append(`administrationData[${index}].minWind`, admin.minWind !== undefined ? admin.minWind.toString() : '0');
            formData.append(`administrationData[${index}].maxWind`, admin.maxWind !== undefined ? admin.maxWind.toString() : '0');
            formData.append(`administrationData[${index}].severity`, admin.severity);
            formData.append(`administrationData[${index}].lighting`, admin.lighting);
            formData.append(`administrationData[${index}].startDate`, toISOStringSafe(admin.startDate, index));
            formData.append(`administrationData[${index}].endDate`, toISOStringSafe(admin.endDate, index));
        });

        const options: RequestInit = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        };

        const response = await fetch(API_EARLY_WARNING_ADD_HWN, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        return responseData as ResponseTypes;
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

// Add Marine weather Warning
const API_EARLY_WARNING_ADD_MWA: string = `${BASE_URL}/ew/api/v1/add_mwa`

export type APIRequestAddMWAAreaTypes = {
    administrationName: string;
    administrationLevel: string;
    minWind: number;
    maxWind: number;
    minWave: number;
    maxWave: number;
    seaCondition: string;
    thunderstorm: string;
    startDate: string;
    endDate: string;
}

export type APIRequestAddMWATypes = {
    mwaNumber: string;
    type?: string;
    requestName: string;
    contactNumber: string;
    preRequestDocument: string;
    validityStartTime: string;
    validityEndTime: string;
    mwaDate: string;
    requestersDepartment: string;
    administrationData: APIRequestAddMWAAreaTypes[];
    messageBodyEnglish: string;
    messageBodyDhivehi: string;
    messageBodySinhala: string;
    reportLink: string;
    supportiveDocuments: File | null;
    warningId: string
}

export const APICallNewMWARequest = async (body: APIRequestAddMWATypes): Promise<ResponseTypes> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const formData = new FormData();

        formData.append("mwaNumber", body.mwaNumber);
        formData.append("type", body.type || "");
        formData.append("requestName", body.requestName);
        formData.append("contactNumber", body.contactNumber);
        formData.append("preRequestDocument", body.preRequestDocument);
        formData.append("validityStartTime", body.validityStartTime);
        formData.append("validityEndTime", body.validityEndTime);
        formData.append("mwaDate", body.mwaDate);
        formData.append("requestersDepartment", body.requestersDepartment);
        formData.append("messageBodyEnglish", body.messageBodyEnglish);
        formData.append("messageBodyDhivehi", body.messageBodyDhivehi);
        formData.append("messageBodySinhala", body.messageBodySinhala);
        formData.append("reportLink", body.reportLink);
        formData.append("warningId", body.warningId)

        if (body.supportiveDocuments) {
            formData.append("supportiveDocuments", body.supportiveDocuments);
        }

        body.administrationData.forEach((admin: APIRequestAddMWAAreaTypes, index: number) => {
            formData.append(`administrationData[${index}].administrationName`, admin.administrationName);
            formData.append(`administrationData[${index}].administrationLevel`, admin.administrationLevel);
            formData.append(`administrationData[${index}].minWind`, admin.minWind !== undefined ? admin.maxWind.toString() : '0');
            formData.append(`administrationData[${index}].maxWind`, admin.maxWind !== undefined ? admin.maxWind.toString() : '0');
            formData.append(`administrationData[${index}].minWave`, admin.minWave !== undefined ? admin.minWave.toString() : '0');
            formData.append(`administrationData[${index}].maxWave`, admin.maxWave !== undefined ? admin.maxWave.toString() : '0');
            formData.append(`administrationData[${index}].seaCondition`, admin.seaCondition);
            formData.append(`administrationData[${index}].thunderstorm`, admin.thunderstorm);
            formData.append(`administrationData[${index}].startDate`, toISOStringSafe(admin.startDate, index));
            formData.append(`administrationData[${index}].endDate`, toISOStringSafe(admin.endDate, index));
        });

        const options: RequestInit = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        };

        const response = await fetch(API_EARLY_WARNING_ADD_MWA, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        return responseData as ResponseTypes;
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

// Add Nuclear Threats Warning
const API_EARLY_WARNING_ADD_NTW: string = `${BASE_URL}/ew/api/v1/add_ntw`

export type APIRequestAddNTWAreaTypes = {
    administrationName: string;
    administrationLevel: string;
    startDate: string;
    endDate: string;
}

export type APIRequestAddNTWTypes = {
    type?: string;

    validityStartTime: string;
    validityEndTime: string;
    administrationData: APIRequestAddNTWAreaTypes[];
    messageBodyEnglish: string;
    messageBodyDhivehi: string;
    messageBodySinhala: string;
    reportLink: string;
    supportiveDocuments: File | null;
    warningId: string;
}

export const APICallNewNTWRequest = async (body: APIRequestAddNTWTypes): Promise<ResponseTypes> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const formData = new FormData();

        formData.append("type", body.type || "");
        formData.append("validityStartTime", body.validityStartTime);
        formData.append("validityEndTime", body.validityEndTime);
        formData.append("messageBodyEnglish", body.messageBodyEnglish);
        formData.append("messageBodyDhivehi", body.messageBodyDhivehi);
        formData.append("messageBodySinhala", body.messageBodySinhala);
        formData.append("reportLink", body.reportLink);
        formData.append("warningId", body.warningId)

        if (body.supportiveDocuments) {
            formData.append("supportiveDocuments", body.supportiveDocuments);
        }

        body.administrationData.forEach((admin: APIRequestAddNTWAreaTypes, index: number) => {
            formData.append(`administrationData[${index}].administrationName`, admin.administrationName);
            formData.append(`administrationData[${index}].administrationLevel`, admin.administrationLevel);
            formData.append(`administrationData[${index}].startDate`, toISOStringSafe(admin.startDate, index));
            formData.append(`administrationData[${index}].endDate`, toISOStringSafe(admin.endDate, index));
        });

        const options: RequestInit = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        };

        const response = await fetch(API_EARLY_WARNING_ADD_NTW, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        return responseData as ResponseTypes;
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

// Add Air Strike Warning
const API_EARLY_WARNING_ADD_ASW: string = `${BASE_URL}/ew/api/v1/add_asw`

export type APIRequestAddASWAreaTypes = {
    administrationName: string;
    administrationLevel: string;
    startDate: string;
    endDate: string;
}

export type APIRequestAddASWTypes = {
    type?: string;

    validityStartTime: string;
    validityEndTime: string;
    administrationData: APIRequestAddASWAreaTypes[];
    messageBodyEnglish: string;
    messageBodyDhivehi: string;
    messageBodySinhala: string;
    reportLink: string;
    supportiveDocuments: File | null;
    warningId: string;
}

export const APICallNewASWRequest = async (body: APIRequestAddASWTypes): Promise<ResponseTypes> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    //console.log(">>>>>>>>>>>>>>>> ASW: ", body)
    try {
        const formData = new FormData();

        formData.append("type", body?.type || "");
        formData.append("validityStartTime", body.validityStartTime);
        formData.append("validityEndTime", body.validityEndTime);
        formData.append("messageBodyEnglish", body.messageBodyEnglish);
        formData.append("messageBodyDhivehi", body.messageBodyDhivehi);
        formData.append("messageBodySinhala", body.messageBodySinhala);
        formData.append("reportLink", body.reportLink);
        formData.append("warningId", body.warningId)

        if (body.supportiveDocuments) {
            formData.append("supportiveDocuments", body.supportiveDocuments);
        }

        body.administrationData.forEach((admin: APIRequestAddASWAreaTypes, index: number) => {
            formData.append(`administrationData[${index}].administrationName`, admin.administrationName);
            formData.append(`administrationData[${index}].administrationLevel`, admin.administrationLevel);
            formData.append(`administrationData[${index}].startDate`, toISOStringSafe(admin.startDate, index));
            formData.append(`administrationData[${index}].endDate`, toISOStringSafe(admin.endDate, index));
        });

        const options: RequestInit = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        };

        const response = await fetch(API_EARLY_WARNING_ADD_ASW, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        return responseData as ResponseTypes;
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

// Add High Wind Warning
/* const API_EARLY_WARNING_GENERATE_MESSAGE: string = `${BASE_URL}/ew/api/v1/generateMessage`

export type APIRequestGenerateMessageAreaTypes = {
    administrationName: string;
    administrationLevel: string;
    minWind: number;
    maxWind: number;
    severity: string;
    lighting: string;
    startDate: string;
    endDate: string;
}

export type APIRequestGenerateMessageTypes = {
    number: string;
    type?: string;
    requestName: string;
    contactNumber: string;
    preRequestDocument: string;
    validityStartTime: string;
    validityEndTime: string;
    primaryCause: string;
    date: string;
    requestersDepartment: string;
    administrationData: APIRequestGenerateMessageAreaTypes[];
    warningId: string;
}

export const APICallGenerateMessageRequest = async (bodyData: APIRequestGenerateMessageTypes): Promise<ResponseTypes> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(bodyData),
        };

        const response = await fetch(API_EARLY_WARNING_GENERATE_MESSAGE, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        return responseData as ResponseTypes;
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
} */

// Get warnings
const API_EARLY_WARNINGS: string = `${BASE_URL}/ew/api/v1/getRequests`

export type APIResponseGetWarningsTypes = {
    id: string;
    warningId: string;
    status: string;
    assignUser: string;
    createdBy: string;
    type: string;
    warningKey: string;
    isSeen: false;
    data: any;
    history: any;
}

export const APICallGetWarningsRequest = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "GET",
            headers: {
                "Context-type": "application/json",
                Authorization: `Bearer ${token}`,
            }
        };

        const response = await fetch(API_EARLY_WARNINGS, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        const newResponse: ResponseTypes = responseData as ResponseTypes
        return newResponse.data as APIResponseGetWarningRequestTypes[]
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}



// Handle accept
/* const API_EARLY_WARNING_ACCEPT: string = `${BASE_URL}/ew/api/v1/acceptEW`

export type APIRequestSelectedUsersType = {
    userId: string;
    sms: string;
    wahtsapp: string;
    viber: string;
}

export type APIResponseEarlyWarningAcceptTypes = {
    warningId: string;
    users: APIRequestSelectedUsersType[];
    groups: string[];
}

export const APICallEarlyWarningAcceptRequest = async (body: APIResponseEarlyWarningAcceptTypes) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body)
        };

        const response = await fetch(API_EARLY_WARNING_ACCEPT, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        return responseData as ResponseTypes
        //return newResponse.data as APIResponseGetWarningsTypes[]
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
} */

// Handle reject
const API_EARLY_WARNING_REJECT: string = `${BASE_URL}/ew/api/v1/rejectEW`

export type APIResponseEarlyWarningRejectTypes = {
    warningId: string;

}

export const APICallEarlyWarningRejectRequest = async (body: APIResponseEarlyWarningRejectTypes) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body)
        };

        const response = await fetch(API_EARLY_WARNING_REJECT, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        return responseData as ResponseTypes
        //return newResponse.data as APIResponseGetWarningsTypes[]
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}











// Add High Wind Warning
//const API_EARLY_WARNING_ADD_NEW: string = `${BASE_URL}/ew/api/v1/add_warning`
const API_EARLY_WARNING_ADD_NEW: string = `${BASE_URL}/ew/api/v1/ew_submission`
export type APIRequestAddAreaTypes = {
    code: string;
    administrationName: string;
    administrationLevel: string;
    minWind?: number;
    maxWind?: number;
    severity?: string;
    //lighting?: string;
    startDate: string;
    endDate: string;
    minWave?: number;
    maxWave?: number;
    previousAlertLevel?: string;
    newAlertLevel?: string;
    rainfall?: number;
    lightingRiskLevel?: string;
    seaCondition?: string;
    thunderstorm?: string;
}

export type APIRequestWarningAddTypes = {
    triggerType: string,
    type: string;
    warningNumber?: string;
    requestName?: string;
    contactNumber?: string;
    preRequestDocument?: string;
    validityStartTime?: string;
    validityEndTime?: string;
    primaryCause?: string;
    lightingRiskLevel?: string;
    warningDate?: string;
    requestersDepartment?: string;
    warningId: string;
    effectedAreas: APIRequestAddAreaTypes[];
    messageBodyEnglish?: string;
    messageBodyDhivehi?: string;
    messageBodySinhala?: string;
    messageBodyBengali?: string;
    messageBodyTamil?: string;
    messageCusBodyEnglish?: string;
    messageCusBodyDhivehi?: string;
    messageCusBodySinhala?: string;
    messageCusBodyBengali?: string;
    messageCusBodyTamil?: string;

    reportLink?: string;
    supportiveDocument?: File | null;
}

export const APICallNewWarningRequest = async (body: APIRequestWarningAddTypes): Promise<ResponseTypes> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    

    try {
        const formData = new FormData();

        formData.append("triggerType", body.triggerType!);
        formData.append("warningNumber", body.warningNumber!);
        formData.append("type", body.type || "");
        formData.append("requestName", body.requestName!);
        formData.append("contactNumber", body.contactNumber!);
        formData.append("preRequestDocument", body.preRequestDocument!);
        formData.append("validityStartTime", body.validityStartTime!);
        formData.append("validityEndTime", body.validityEndTime!);
        formData.append("primaryCause", body.primaryCause!);
        formData.append("warningDate", body.warningDate!);
        formData.append("requestersDepartment", body.requestersDepartment!);
        formData.append("messageBodyEnglish", body.messageBodyEnglish!);
        formData.append("messageBodyDhivehi", body.messageBodyDhivehi!);
        formData.append("messageBodySinhala", body.messageBodySinhala!);
        formData.append("messageBodyBengali", body.messageBodyBengali!);
        formData.append("messageBodyTamil", body.messageBodyTamil!);
        formData.append("messageCusBodyEnglish", body.messageCusBodyEnglish!);
        formData.append("messageCusBodyDhivehi", body.messageCusBodyDhivehi!);
        formData.append("messageCusBodySinhala", body.messageCusBodySinhala!);
        formData.append("messageCusBodyBengali", body.messageCusBodyBengali!);
        formData.append("messageCusBodyTamil", body.messageCusBodyTamil!);
        formData.append("reportLink", body.reportLink!);
        formData.append("warningId", body.warningId)
        formData.append("lightingRiskLevel", body.lightingRiskLevel!);

        if (body.supportiveDocument) {
            formData.append("supportiveDocuments", body.supportiveDocument);
        }

        body.effectedAreas.forEach((admin: APIRequestAddAreaTypes, index: number) => {
            formData.append(`effectedAreas[${index}].adminName`, admin.administrationName);
            formData.append(`effectedAreas[${index}].adminLevel`, admin.administrationLevel);
            formData.append(`effectedAreas[${index}].minWind`, admin.minWind !== undefined ? admin.minWind.toString() : '0');
            formData.append(`effectedAreas[${index}].maxWind`, admin.maxWind !== undefined ? admin.maxWind.toString() : '0');
            formData.append(`effectedAreas[${index}].minWave`, admin.minWave !== undefined ? admin.minWave.toString() : '0');
            formData.append(`effectedAreas[${index}].maxWave`, admin.maxWave !== undefined ? admin.maxWave.toString() : '0');
            formData.append(`effectedAreas[${index}].severity`, admin.severity!);
            //formData.append(`effectedAreas[${index}].lightning`, admin.lighting!);
            formData.append(`effectedAreas[${index}].validityStart`, admin.startDate);
            formData.append(`effectedAreas[${index}].validityEnd`, admin.endDate);
            formData.append(`effectedAreas[${index}].previousAlert`, admin.previousAlertLevel!);
            formData.append(`effectedAreas[${index}].newAlert`, admin.newAlertLevel!);
            formData.append(`effectedAreas[${index}].rainfall`, admin.rainfall !== undefined ? admin.rainfall.toString() : '0');
            formData.append(`effectedAreas[${index}].lightningRisk`, admin.lightingRiskLevel!);
            formData.append(`effectedAreas[${index}].seaCondition`, admin.seaCondition!);
            formData.append(`effectedAreas[${index}].thunderstorm`, admin.thunderstorm!);
            formData.append(`effectedAreas[${index}].code`, admin.code!);
        });

        const options: RequestInit = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        };
        //console.log(">>>>>>>>>>>>>> API_EARLY_WARNING_ADD_NEW: ", formData)
        const response = await fetch(API_EARLY_WARNING_ADD_NEW, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        return responseData as ResponseTypes;
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

// Generate EW general message
const API_EARLY_WARNING_MESSAGE_GENERATE_REQUEST: string = `${BASE_URL}/ew/api/v1/generate_warningmsg`

export const APICallGenerateEWMsgRequest = async (body: APIRequestWarningAddTypes): Promise<ResponseTypes> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    

    try {
        const formData = new FormData();

        formData.append("triggerType", body.triggerType!);
        formData.append("warningNumber", body.warningNumber!);
        formData.append("type", body.type || "");
        formData.append("requestName", body.requestName!);
        formData.append("contactNumber", body.contactNumber!);
        formData.append("preRequestDocument", body.preRequestDocument!);
        formData.append("validityStartTime", body.validityStartTime!);
        formData.append("validityEndTime", body.validityEndTime!);
        formData.append("primaryCause", body.primaryCause!);
        formData.append("warningDate", body.warningDate!);
        formData.append("requestersDepartment", body.requestersDepartment!);
        formData.append("messageBodyEnglish", body.messageBodyEnglish!);
        formData.append("messageBodyDhivehi", body.messageBodyDhivehi!);
        formData.append("messageBodySinhala", body.messageBodySinhala!);
        formData.append("messageBodyBengali", body.messageBodyBengali!);
        formData.append("reportLink", body.reportLink!);
        formData.append("warningId", body.warningId)
        formData.append("lightingRiskLevel", body.lightingRiskLevel!);
        if (body.supportiveDocument) {
            formData.append("supportiveDocuments", body.supportiveDocument);
        }

        body.effectedAreas.forEach((admin: APIRequestAddAreaTypes, index: number) => {
            formData.append(`effectedAreas[${index}].adminName`, admin.administrationName);
            formData.append(`effectedAreas[${index}].adminLevel`, admin.administrationLevel);
            formData.append(`effectedAreas[${index}].minWind`, admin.minWind !== undefined ? admin.minWind.toString() : '0');
            formData.append(`effectedAreas[${index}].maxWind`, admin.maxWind !== undefined ? admin.maxWind.toString() : '0');
            formData.append(`effectedAreas[${index}].minWave`, admin.minWave !== undefined ? admin.minWave.toString() : '0');
            formData.append(`effectedAreas[${index}].maxWave`, admin.maxWave !== undefined ? admin.maxWave.toString() : '0');
            formData.append(`effectedAreas[${index}].severity`, admin.severity!);
            //formData.append(`effectedAreas[${index}].lightning`, admin.lighting!);
            formData.append(`effectedAreas[${index}].validityStart`, admin.startDate);
            formData.append(`effectedAreas[${index}].validityEnd`, admin.endDate);
            formData.append(`effectedAreas[${index}].previousAlert`, admin.previousAlertLevel!);
            formData.append(`effectedAreas[${index}].newAlert`, admin.newAlertLevel!);
            formData.append(`effectedAreas[${index}].rainfall`, admin.rainfall !== undefined ? admin.rainfall.toString() : '0');
            formData.append(`effectedAreas[${index}].lightningRisk`, admin.lightingRiskLevel!);
            formData.append(`effectedAreas[${index}].seaCondition`, admin.seaCondition!);
            formData.append(`effectedAreas[${index}].thunderstorm`, admin.thunderstorm!);
            formData.append(`effectedAreas[${index}].code`, admin.code!);
        });

        const options: RequestInit = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        };

        const response = await fetch(API_EARLY_WARNING_MESSAGE_GENERATE_REQUEST, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        return responseData as ResponseTypes;
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}





// Get warnings
/* const API_EARLY_WARNING_REQUEST: string = `${BASE_URL}/ew/api/v1/getRequests`

export type APIResponseGetWarningRequestTypes = {
    id: string;
    earlyWarningId: string;
    status: string;
    assignUser: string;
    createdBy: string;
    type: string;
    warningKey: string;
    addDate: string;
    users: string;
    groups: string;
    warning: any;
    history: any;
    isSeen: boolean;
}

export const APICallGetWarningRequestRequest = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }
        };

        const response = await fetch(API_EARLY_WARNING_REQUEST, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        const newResponse: ResponseTypes = responseData as ResponseTypes
        return newResponse.data as APIResponseGetWarningRequestTypes[]
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
} */

// accept warnings
const API_WARNING_ACCEPT: string = `${BASE_URL}/ew/api/v1/approve`

export type APIRequestSelectedSubscribersType = {
    userId: string;
    sms: boolean;
    whatsapp: boolean;
    viber: boolean;
}

export type APIResponseSelectedSubscribersType = {
    addUser: string;
    id: APIResponseSelectedSubscribersIdType;
    sms: boolean;
    whatsapp: boolean;
    viber: boolean;
}

export type APIResponseSelectedSubscribersIdType = {
    warningId: string;
    userId: string;
}

export type APIWarningAcceptRequestTypes = {
    warningId: string;
    warningCatType: string;
    recipients: string[];
    selectedGroups: string[];
    selectedSubscribers: APIRequestSelectedSubscribersType[];
    warningCatMType: string;
    comment: string;
    /* users: APIRequestSelectedUsersType[];
    groups: string[];
    recipients: string[];
    earlyWarningId: string; */
}

export const APICallWarningAcceptRequest = async (body: APIWarningAcceptRequestTypes, token: string) => {
    //const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body)
        };

        const response = await fetch(API_WARNING_ACCEPT, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }

}

export type APIWarningAcknowledgeRequestTypes = {
    selectedGroups: string[];
    selectedSubscribers: APIRequestSelectedSubscribersType[];
}

export type APIWarningAcknowledgeRequestInternalTypes = {
    selectedGroups: string[];
    selectedSubscribers: APIRequestSelectedSubscribersType[];
    warningId: string;
}

export type APISaveGroupSubTypes = {
    selectedGroups: string[];
    selectedSubscribers: APIRequestSelectedSubscribersType[];
    warningId: string;
    workflowId: string;
}

const API_WARNING_ACCEPT_EXTERNAL: string = `${BASE_URL}/jwt-auth/api/v1/approve`

export const APICallWarningAcceptRequestExternal = async (body: APIWarningAcceptRequestTypes, token: string) => {
    //const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body)
        };

        const response = await fetch(`${API_WARNING_ACCEPT_EXTERNAL}?token=${token}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }

}

// Get process key 
const URL_API_GENARATE_PROC_KEY: string = `${BASE_URL}/ew/api/v1/generateProcKey`

export type APIGenerateProcKeyRequestTypes = {
    wType: string;
 }

export const APICallGenerateProcKeyRequest = async (wType: string) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {

        /* const reqbody = {
            wType: body.hazardType,
            //wDescription: body.wDescription,
            wName: body.warningName,
            wCode: body.warningId,
            //sDescription: body.sDescription
        }; */
        const body: APIGenerateProcKeyRequestTypes = {
            wType: wType
        }

        const options: RequestInit = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body)
        };

        //const URL_API_GENARATE_PROC_KEY = new URL(API_GENARATE_PROC_KEY);
        //URL_API_GENARATE_PROC_KEY.searchParams.append("wType", body.hazardType);
        //URL_API_GENARATE_PROC_KEY.searchParams.append("wName", body.warningName);
        //URL_API_GENARATE_PROC_KEY.searchParams.append("wCode", body.warningId);



        const response = await fetch(URL_API_GENARATE_PROC_KEY, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}


const API_GET_PENDING_BY_ID: string = `${BASE_URL}/ew/api/v1/getPending`

export const APICallGetPendingRequest = async (id: string) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        const response = await fetch(`${API_GET_PENDING_BY_ID}?id=${id}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

const API_GET_WARNING_TYPE: string = `${BASE_URL}/workflow_engine/api/v1/getuserflowsetups`

export type APIWarningTypeResponseType = {
    warningId: string;
    departments: string;
    hazardType: string;
    warningName: string;
    warningType: string;
}

export const APICallGetWarningTypeRequest = async (username: string) => {

    const URL: string = `${BASE_URL}/workflow_engine/api/v1/getuserflowsetups`
    const HEADER: RequestInit = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${getToken()}`,
        }
    }

    try 
    {
        const response = await fetch(`${URL}?username=${username}`, HEADER);
        const responseData = await response.json();

        if (!response.ok) 
        {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as APIWarningTypeResponseType[]
    } 
    catch (error) 
    {
        console.error("API call error:", error);
        throw error;
    }
}

// reject warnings
const API_WARNING_REJECT: string = `${BASE_URL}/ew/api/v1/rejectEW`

export type APIWarningRejectRequestTypes = {
    warningId: string;
    warningType: string;
}

export const APICallWarningAcceptRejectRequest = async (body: APIWarningRejectRequestTypes, token: string) => {
    //const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body)
        };

        const response = await fetch(API_WARNING_REJECT, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

const API_WARNING_REJECT_EXTERNAL: string = `${BASE_URL}/jwt-auth/api/v1/rejectEW`

export const APICallWarningAcceptRejectRequestExternal = async (body: APIWarningRejectRequestTypes, token: string) => {
    //const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body)
        };

        const response = await fetch(`${API_WARNING_REJECT_EXTERNAL}?token=${token}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

// reject warnings
const API_GET_USER_INFO: string = `${BASE_URL}/identity_manager/api/v1/getuser`

export type APIGetUserDetailsTypes = {
    id: string | null;
    username: string;
    email: string;
    password: string | null;
    country: string;
    firstname: string;
    lastname: string;
    address: string;
    mobilenumber: string;
    organization: string;
    department: string;
    role: string;
    nic: string;
    policies: string;
    accessprivileges: string;
    thememodebconex: 'light' | 'dark';
    themecolorbconex: string;
    thememodeeaglei: 'light' | 'dark';
    profilePicUrl: string | null;
};

export const APICallGetUserInfoRequest = async (username: string) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        const response = await fetch(`${API_GET_USER_INFO}/${username}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as APIGetUserDetailsTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }

}

// Add High Wind Warning
const API_EARLY_WARNING_MESSAGE: string = `${BASE_URL}/ew/api/v1/generate_warningmsg`

export type APIRequestGenerateEWMessageTypes = {
    triggerType: string;
    type: string;
    warningNumber?: string;
    requestName?: string;
    contactNumber?: string;
    preRequestDocument?: string;
    validityStartTime?: string;
    validityEndTime?: string;
    primaryCause?: string;
    lightingRiskLevel?: string;
    warningDate?: string;
    requestersDepartment?: string;
    warningId: string;
    effectedAreas: APIRequestAddAreaTypes[];
    messageBodyEnglish?: string;
    messageBodyDhivehi?: string;
    messageBodySinhala?: string;
    reportLink?: string;
    supportiveDocument?: File | null;
}

export type APIResponseGenerateEWMessageTypes = {
    ew_generalMsgLanBase: string;
    ew_generalMsgLan1: string;
    ew_generalMsgLan2: string;
    ew_generalMsgLan3: string;
    ew_generalMsgLan4: string;
    ew_generalMsgLan5: string;
}

export const APICallGenerateMessageRequest = async (body: APIRequestGenerateEWMessageTypes): Promise<ResponseTypes> => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    

    try {
        const formData = new FormData();

        formData.append("triggerType", body.triggerType!);
        formData.append("warningNumber", body.warningNumber!);
        formData.append("type", body.type || "");
        formData.append("requestName", body.requestName!);
        formData.append("contactNumber", body.contactNumber!);
        formData.append("preRequestDocument", body.preRequestDocument!);
        formData.append("validityStartTime", body.validityStartTime!);
        formData.append("validityEndTime", body.validityEndTime!);
        formData.append("primaryCause", body.primaryCause!);
        formData.append("warningDate", body.warningDate!);
        formData.append("requestersDepartment", body.requestersDepartment!);

        if (body.supportiveDocument) {
            formData.append("supportiveDocuments", body.supportiveDocument);
        }

        body.effectedAreas.forEach((admin: APIRequestAddAreaTypes, index: number) => {
            formData.append(`effectedAreas[${index}].adminName`, admin.administrationName);
            formData.append(`effectedAreas[${index}].adminLevel`, admin.administrationLevel);
            formData.append(`effectedAreas[${index}].minWind`, admin.minWind !== undefined ? admin.minWind.toString() : '0');
            formData.append(`effectedAreas[${index}].maxWind`, admin.maxWind !== undefined ? admin.maxWind.toString() : '0');
            formData.append(`effectedAreas[${index}].minWave`, admin.minWave !== undefined ? admin.minWave.toString() : '0');
            formData.append(`effectedAreas[${index}].maxWave`, admin.maxWave !== undefined ? admin.maxWave.toString() : '0');
            formData.append(`effectedAreas[${index}].severity`, admin.severity!);
            //formData.append(`effectedAreas[${index}].lightning`, admin.lighting!);
            formData.append(`effectedAreas[${index}].validityStart`, admin.startDate);
            formData.append(`effectedAreas[${index}].validityEnd`, admin.endDate);
            formData.append(`effectedAreas[${index}].previousAlert`, admin.previousAlertLevel!);
            formData.append(`effectedAreas[${index}].newAlert`, admin.newAlertLevel!);
            formData.append(`effectedAreas[${index}].rainfall`, admin.rainfall !== undefined ? admin.rainfall.toString() : '0');
            formData.append(`effectedAreas[${index}].lightningRisk`, admin.lightingRiskLevel!);
            formData.append(`effectedAreas[${index}].seaCondition`, admin.seaCondition!);
            formData.append(`effectedAreas[${index}].thunderstorm`, admin.thunderstorm!);
            formData.append(`effectedAreas[${index}].code`, admin.code!);
        });

        const options: RequestInit = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        };

        const response = await fetch(API_EARLY_WARNING_MESSAGE, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        return responseData as ResponseTypes;
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

// Get subscribed users
const API_GET_SUBSCRIBE_USERS: string = `${BASE_URL}/ew/api/v1/get_subscribed_users`

export type APISubscribeUsersTypes = {
    warningId: string;
    username: string;
    sms: boolean;
    whatsapp: boolean;
    viber: boolean;
}

export const APICallGetSubscribedUsersRequest = async (warningId: string) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        const response = await fetch(`${API_GET_SUBSCRIBE_USERS}/${warningId}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }

}

// Get subscribed groups
const API_GET_SUBSCRIBE_GROUPS: string = `${BASE_URL}/ew/api/v1/get_subscribed_groups`

export type APISubscribeGroupTypes = {
    warningId: string;
    groupId: string;
    type: string;
}

export const APICallGetSubscribedGroupRequest = async (warningId: string) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        const response = await fetch(`${API_GET_SUBSCRIBE_GROUPS}/${warningId}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }

}



// New subscriber
const API_NEW_SUBSCRIBE_USER: string = `${BASE_URL}/ew/api/v1/new_subscriber`

export type APISubscribeUserNewTypes = {
    id: string;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    email: string;
    sms: boolean;
    whatsapp: boolean;
    viber: boolean;
    groups: string[];
    areas: string[];
    hazards : string[];
    userType: string;
    language: string;
}

export const APICallNewSubscriberRequest = async (body: APISubscribeUserNewTypes) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body)
        };

        const response = await fetch(`${API_NEW_SUBSCRIBE_USER}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

// New Group
const API_NEW_GROUP_USER: string = `${BASE_URL}/ew/api/v1/new_group`

export type APISubscribeGroupNewTypes = {
    id: string;
    groupName: string;
    groupDescription: string;
    groupOrganization: string;
    groupDepartment: string;
}

export const APICallNewSubscriberGroupRequest = async (body: APISubscribeGroupNewTypes) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body)
        };

        const response = await fetch(`${API_NEW_GROUP_USER}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}


const API_GET_ALL_SUBSCRIBERS: string = `${BASE_URL}/ew/api/v1/get_all_subscribers`

export type APIGroupTypes = {
    id: string;
    groupName: string;
    groupDescription: string;
    groupOrganization: string;
    groupDepartment: string;
}

export type APISubscriberType = {
    id: string;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    email: string;
    sms: boolean;
    whatsapp: boolean;
    viber: boolean;
    groups: APIGroupTypes[];
    userType: string;
    areas?: string[];
    hazards?: string[];
    language: string;
}

export const APICallGetAllSubscriberRequest = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await fetch(`${API_GET_ALL_SUBSCRIBERS}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

// ***** ADD: new warning info getting url
const API_GET_WARNING_INFO: string = `${BASE_URL}/ew/api/v1/getWarningDetails`

export type APIResponseHistoryRecipientType = {
    username: string;
    firstName: string;
    lastName: string;
    role: string;
    email: string;
    contactNumber: string;
    status: string;
    performedDate: string;
    department: string;
    areaList: string[];
}

export type APIResponseHistoryType = {
    performedUser: string;
    status: string;
    performedDate: string; // ISO string, e.g., "2025-07-16T12:34:56"
    createdAt: string;
    warningType: string;
    userRole: string;
    userEmail: string;
    userContact: string;
    department: string;
    recipients: APIResponseHistoryRecipientType[];
}

export type APIResponseWarningType = {
    warningNumber: string;
    requestName: string;
    contactNumber: string;
    preRequestDocument: string;
    validityStartTime: string; // ISO string with timezone
    validityEndTime: string;   // ISO string with timezone
    primaryCause: string;
    lightingRiskLevel: string;
    warningDate: string; // ISO string with timezone
    requestersDepartment: string;
    warningId: string;
    messageBodyEnglish: string;
    messageBodyDhivehi: string;
    messageBodySinhala: string;
    messageBodyBengali: string;
    messageBodyTamil: string;
    reportLink: string;
    supportiveDocument: string; // 'MultipartFile' -> File in TypeScript
    history: APIResponseHistoryType[];
    status: string;
    comment: string;
    workflow: string;
    catMType: string;
    currentStatus: string;
    tableData: string;
}

export const APICallGetWarningInfoByWarningId = async (warningId: string, type: string, token: string) => {
    //const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await fetch(`${API_GET_WARNING_INFO}?warningId=${warningId}&type=${type}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

const API_GET_WARNING_INFO_EXTERNAL: string = `${BASE_URL}/jwt-auth/api/v1/getWarningDetails`

// For external
export const APICallGetWarningInfoByWarningIdExternal = async (type: string, token: string) => {
    //const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        };

        const response = await fetch(`${API_GET_WARNING_INFO_EXTERNAL}?token=${token}&type=${type}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        //const newResponse: ResponseTypes = responseData as ResponseTypes
        return responseData as ResponseTypes
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

// Get warning info
export type APIResponseGetWarningRequestTypes = {
    warningId: string;
    status: string;
    title: string;
    isSeen: boolean;
    type: string;
    createAt: string;
    warningCatType: string;
}

export const APICallGetAllWarningInfoRequest = async () => {

    const URL: string = `${BASE_URL}/ew/api/v1/getAllWarningDetails`
    const HEADER: RequestInit = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
        }
    }

    try 
    {
        const response = await fetch(URL, HEADER);
        const responseData = await response.json();

        if (!response.ok) 
        {
            throw new Error(responseData.message || "Request failed")
        }
        
        const newResponse: ResponseTypes = responseData as ResponseTypes
        return newResponse.data as APIResponseGetWarningRequestTypes[]
    } 
    catch (error) 
    {
        console.error("API call error:", error);
        throw error;
    }
}

// Get recipients
const API_GET_RECIPIENTS: string = `${BASE_URL}/ew/api/v1/getSelectedRecipients`

export type APIResponseGetRecipientRequestTypes = {
    recipient: string;
    username: string;
    department: string;
}

export const APICallGetAllRecipientRequest = async (catCode: string, token: string) => {
    //const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }
        };

        const response = await fetch(`${API_GET_RECIPIENTS}?catCode=${catCode}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        const newResponse: ResponseTypes = responseData as ResponseTypes
        return newResponse.data as APIResponseGetRecipientRequestTypes[]
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

// Get recipients
const API_GET_RECIPIENTS_EXTERNAL: string = `${BASE_URL}/jwt-auth/api/v1/getSelectedRecipients`

export const APICallGetAllRecipientRequestExternal = async (token: string, catCode: string) => {
    //const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }

    try {
        const options: RequestInit = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        };

        const response = await fetch(`${API_GET_RECIPIENTS_EXTERNAL}?token=${token}&catCode=${catCode}`, options);
        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.message || "Request failed");
        }

        const newResponse: ResponseTypes = responseData as ResponseTypes
        return newResponse.data as APIResponseGetRecipientRequestTypes[]
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}